module.exports = __webpack_public_path__ + "img/triple-btn-bg.d6f0a69c.svg";